/** Curated wall / rug swatches for personal offices. */

export const OFFICE_WALL_SWATCHES = [
  "#E6EBF2",
  "#F5E6D3",
  "#D4E5F7",
  "#E8D5E8",
  "#D5E8D5",
  "#F0E6D2",
  "#001847",
  "#2C3E50",
] as const;

export const OFFICE_RUG_SWATCHES = [
  "#C8D0DC",
  "#2D9BD6",
  "#64479D",
  "#2EA86A",
  "#D8443C",
  "#E8A93C",
  "#1E6CC7",
  "#5C4033",
] as const;

const WALL_SET = new Set<string>(OFFICE_WALL_SWATCHES);
const RUG_SET = new Set<string>(OFFICE_RUG_SWATCHES);

export type OfficeTheme = {
  wallColor: string;
  rugColor: string;
};

export const DEFAULT_OFFICE_THEME: OfficeTheme = {
  wallColor: "#E6EBF2",
  rugColor: "#C8D0DC",
};

function pickSwatch(value: unknown, allowed: Set<string>, fallback: string): string {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  // Normalize common hex case so clients sending lowercase still match.
  const candidates = [trimmed, trimmed.toUpperCase(), trimmed.toLowerCase()];
  for (const c of candidates) {
    if (allowed.has(c)) return c;
  }
  // Exact match against allowlist members ignoring case
  for (const sw of allowed) {
    if (sw.toLowerCase() === trimmed.toLowerCase()) return sw;
  }
  return fallback;
}

export function normalizeOfficeTheme(raw: unknown): OfficeTheme {
  const o = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  return {
    wallColor: pickSwatch(o.wallColor, WALL_SET, DEFAULT_OFFICE_THEME.wallColor),
    rugColor: pickSwatch(o.rugColor, RUG_SET, DEFAULT_OFFICE_THEME.rugColor),
  };
}

export function isAllowedWallColor(color: string): boolean {
  return pickSwatch(color, WALL_SET, "") !== "";
}

export function isAllowedRugColor(color: string): boolean {
  return pickSwatch(color, RUG_SET, "") !== "";
}
